export const gradeOptions = [
  { value: null, text: '選択してください' },
  { value: 1, text: '小学1年生' },
  { value: 2, text: '小学2年生' },
  { value: 3, text: '小学3年生' },
  { value: 4, text: '小学4年生' },
  { value: 5, text: '小学5年生' },
  { value: 6, text: '小学6年生' },
  { value: 7, text: '中学1年生' },
  { value: 8, text: '中学2年生' },
  { value: 9, text: '中学3年生' },
  { value: 10, text: '高校1年生' },
  { value: 11, text: '高校2年生' },
  { value: 12, text: '高校3年生' },
  { value: 13, text: '大学1年生' },
  { value: 14, text: '大学2年生' },
  { value: 15, text: '大学3年生' },
  { value: 16, text: '大学4年生' },
  { value: 99, text: 'その他' },
]

export const textByGradeCode = gradeOptions.reduce((acc, option) => {
  acc[option.value] = option.text
  return acc
}, {})

export const gradeCodeToGrade = gradeCode => {
  return textByGradeCode[gradeCode] || gradeCode
}

// 成績管理は小学生、中学生、高校生、その他のみ
export const academicRecordGradeCodes = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 99,
]
export const academicRecordGradeCodeOptions = gradeOptions.filter(option => academicRecordGradeCodes.includes(option.value))

// 体重身長管理はそのまま
export const bodyMeasurementGradeCodeOptions = gradeOptions

export const isJuniorHighSchool = gradeCode => {
  return gradeCode >= 7 && gradeCode <= 9
}

export const isHighSchool = gradeCode => {
  return gradeCode >= 10 && gradeCode <= 12
}

export const canInputSubjectScores = gradeCode => {
  return gradeCode >= 7
}

export const canInputSubjectTitles = gradeCode => {
  return gradeCode >= 10
}

export const canInputTestResults = gradeCode => {
  return gradeCode >= 7
}

export const semesterOptions = [
  { value: null, text: '選択してください' },
  { value: 'SEMESTER_1', text: '1学期' },
  { value: 'SEMESTER_2', text: '2学期' },
  { value: 'SEMESTER_3', text: '3学期' },
  { value: 'SEMESTER_4', text: '4学期' },
  { value: 'FIRST_HALF', text: '前期' },
  { value: 'SECOND_HALF', text: '後期' },
]

export const semesterSortNumByValue = {
  'SEMESTER_1': 1,
  'SEMESTER_2': 2,
  'SEMESTER_3': 3,
  'SEMESTER_4': 4,
  'FIRST_HALF': 5,
  'SECOND_HALF': 6,
}

export const textBySemester = semesterOptions.reduce((acc, option) => {
  acc[option.value] = option.text
  return acc
}, {})

export const semesterToText = semester => {
  return textBySemester[semester] || semester
}

export const juniorHighSchoolSubjectTitles = [
  '国語',
  '社会',
  '数学',
  '理科',
  '英語',
  '音楽',
  '美術',
  '保健体育',
  '技術家庭',
]

export const juniorHighSchool5SubjectTitles = [
  '国語',
  '社会',
  '数学',
  '理科',
  '英語',
]

export const testNamesOptions = [
  { value: 'MIDTERM', text: '中間テスト' },
  { value: 'FINAL', text: '期末テスト' },
  { value: 'YEAREND', text: '学年末テスト' },
  { value: 'ACHIEVEMENT', text: '実力テスト' },
  { value: 'NATIONAL', text: '全国テスト' },
  { value: 'ASSIGNMENT', text: '課題テスト' },
  { value: 'MOCK', text: '模擬テスト' },
  { value: 'OTHER', text: 'その他' },
]

export const textByTestName = testNamesOptions.reduce((acc, option) => {
  acc[option.value] = option.text
  return acc
}, {})

export const testNameToText = testName => {
  return textByTestName[testName] || testName
}

export const scoreOptions = [
  { value: null, text: '5段階' },
  { value: 1, text: '1' },
  { value: 2, text: '2' },
  { value: 3, text: '3' },
  { value: 4, text: '4' },
  { value: 5, text: '5' },
]

export const residencePreferenceOptions = [
  { value: 'dormitory', text: '寮生活を希望' },
  { value: 'home', text: '自宅から通いたい' },
  { value: 'both', text: '寮・自宅どちらもOK' },
  { value: 'alone', text: '1人暮らしを希望' },
  { value: 'other', text: 'その他' },
]

export const preferredPathOptions = [
  { value: 'public_school', text: '公立の学校を希望' },
  { value: 'private_school', text: '私立の学校を希望' },
  { value: 'internal_advancement', text: '内部進学を希望' },
  { value: 'vocational_school', text: '専門学校を希望' },
  { value: 'employment', text: '就職を希望' },
  { value: 'pro_club', text: 'プロクラブを希望' },
  { value: 'social_team', text: '社会人チームを希望' },
  { value: 'other', text: 'その他' },
]

export const examTypeOptions = [
  { value: 'sports_recommendation', text: 'スポーツ推薦を希望' },
  { value: 'general_exam', text: '一般受験を希望' },
  { value: 'designated_school', text: '指定校推薦を希望' },
  { value: 'public_recommendation', text: '公募推薦を希望' },
  { value: 'comprehensive_selection', text: '総合型選抜を希望' },
  { value: 'other', text: 'その他' },
]

export const getStudentNumberText = member => {
  const parts = []
  if (member.grade) {
    const gradeText = gradeCodeToGrade(member.grade)
    if (gradeText) parts.push(gradeText)
  }
  if (member.homeroom) parts.push(`${member.homeroom}組`)
  if (member.attendanceNumber) parts.push(`${member.attendanceNumber}番`)
  return parts.join(' ')
}
